<template>
  <!--Main Content-->
  <div class="main-content px-0 app-content">
    <!--Main Content Container-->
    <div class="container-fluid">
      <!--Page Header-->
      <Breadcrumb />
      <!--Page Header-->
      <!-- <div class="forms mb-5 card rounded">
        <VendorForm :user="this.user" />
      </div> -->

      <div class="">
        <div class="row row-sm">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
            <div class="card">
              <div class="card-body pb-0 border-bottom">
                <div class="d-flex mb-3">
                  <h6 class="card-title mb-0">Vendors</h6>
                  <div class="card-option ml-auto d-none d-md-flex">
                    <div class="mr-2">
                      <!-- <router-link to="/createmaintenance"><button class="btn btn-primary btn-sm rounded-lg fs-13"><i class="mdi mdi-plus-circle-outline"></i>Create New Maintenance </button></router-link> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="">
                <form class="card m-3" @submit.prevent="getVendors()">
                  <div class="m-3 p-3 row">
                    <div class="col-md-6">
                      <!-- <h5 class="mb-3 bg-light p-2">Generate By Date</h5> -->
                      <p>Start Date</p>
                      <input
                        class="form-control"
                        type="date"
                        required
                        v-model="startDate"
                        name="start"
                      />
                    </div>

                    <div class="col-md-6">
                      <!-- <h5 class="mb-3 bg-light p-2">
                      Generate By Category Or Status
                    </h5> -->

                      <p>End Date</p>
                      <input
                        v-model="endDate"
                        class="form-control"
                        type="date"
                        required
                        name="end"
                      />
                    </div>

                    <button v-if="loading" class="btn btn-primary" disabled>
                      Loading
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span style="width: 2px" class="sr-only text-light"
                          >Loading...</span
                        >
                      </div>
                    </button>

                    <input
                      v-else-if="vendors.length == 0"
                      class="ml-3 btn btn-primary"
                      type="submit"
                      value="Generate"
                    />
                    <button class="ml-5 btn btn-warning" @click.prevent="reset">
                      Reset
                    </button>
                  </div>
                </form>
                <div class="card m-3">
                  <div class="table-responsive">
                    <table
                      id="example"
                      class="table table-striped"
                      style="width: 100%"
                    >
                      <thead>
                        <tr>
                          <th>Vendor Registered Company Name</th>
                          <th>Vendor Company Registration Number</th>
                          <th>Vendor Tax Identification Number</th>
                          <th>Vendor Address</th>
                          <th>Vendor Telephone Number</th>
                          <th>Vendor Mobile Number</th>
                          <th>Vendor email</th>
                          <th>Vendor Website</th>
                          <th>Vendor Industry</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="vendor in vendors"
                          :key="vendor.registeredCompanyName"
                        >
                          <td>{{ vendor.registeredCompanyName }}</td>
                          <td>{{ vendor.companyRegistrationNumber }}</td>
                          <td>{{ vendor.taxIdentificationNumber }}</td>
                          <td>{{ vendor.address }}</td>
                          <td>{{ vendor.telephoneNumber }}</td>
                          <td>{{ vendor.mobileNumber }}</td>
                          <td>{{ vendor.email }}</td>
                          <td>{{ vendor.website }}</td>
                          <td>{{ vendor.industry }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- COL END -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
//import VendorForm from "@/components/VendorForm";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  components: {
    //VendorForm,
    Breadcrumb,
  },

  props: ["user", "BaseURL"],

  data() {
    return {
      loading: false,
      vendors: [],

      startDate: "",
      endDate: "",
      categoryId: 0,
      status: "",
    };
  },

  methods: {
    getVendors() {
      this.loading = true;
      fetch(this.BaseURL + "/getVendorReport", {
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          this.vendors = data;

          if (this.vendors.length == 0) {
            this.loading = false;
            alert(
              `No Data Available Within Specified Date Or Category To Show`
            );
          } else {
            this.loading = false;
            $(() => {
              $("#example").DataTable({
                dom: "Bfrtip",
                buttons: [
                  "colvis",
                  "copyHtml5",
                  "csvHtml5",
                  "excel",
                  "pdf",
                  "print",
                ],
              });
            });
          }
          //console.log(data);
          // this.isSuccessful = data.isSuccess;
          // this.errorMessage = data.message;
        });
    },

    reset() {
      window.location.reload(true);
    },

    beforeCreate() {
      if (localStorage.getItem("role") !== "User") {
        window.location = "/error";
      }
    },

    created() {
      this.getVendors;
    },
  },
};
</script>